export default __webpack_public_path__ + "static/media/NumberOfTrialsIcon.13aa7767.svg";